import { navigate } from "@reach/router"


const platform = require('platform');
const isBrowser = typeof window !== `undefined`
const axios = require('axios').default;
const _ = require('lodash');

const getUserData = () =>
  window.localStorage.doneracookie
    ? JSON.parse(window.localStorage.doneracookie)
    : {}

const getAdminUserData = () =>
  window.localStorage.admincookie
    ? JSON.parse(window.localStorage.admincookie)
    : null


export const setLoggedInUser = userdata => (window.localStorage.doneracookie = JSON.stringify(userdata))

const setUserData = userdata => (window.localStorage.doneracookie = JSON.stringify(userdata))

const setAdminUserData = elevatedcookie => (window.localStorage.admincookie = JSON.stringify(elevatedcookie))

export const handleLoginAdmin = (callback) => {
  if (!isBrowser) return false

  loginAdmin(callback);

  return true
}

function loginAdmin(callback) {
  const userdata = getCurrentUser();
  const options = {
    method: "post",
    url: `${api_base_url()}/${userdata.cookie}/elevate`,
    data: {
      BrowserData: browserstring(),
    },
  }

  axios(options)
    .then(response => {
      setAdminUserData(response.data.elevated);
      callback(response.data.elevated)
    })
}

export const isAdmin = () => {
  if (!isBrowser) return false

  const elevated = getAdminUserData();

  return !!elevated
}

function loginUser(username, password, redirectPath, loginFailedCallback) {
  axios({
    method: 'post',
    url: `${api_base_url()}/login`,
    data: {
      username: username.toLowerCase(),
      password: password,
      browser_data: browserstring()
    }
  }).then(function(response) {
    // alert("Login lyckades. Ny cookie: " + response.data.cookieid)
    setUserData({
      username: response.data.username,
      cookie: response.data.cookieid
    });

    if (!_.isEmpty(redirectPath)) {
      navigate(redirectPath);
    }
  })
    .catch(e => {
      loginFailedCallback("Login failed")
    });

  return false

}

export const handleLogin = ({ username, pwd }, redirectPath, loginFailedCallback) => {
  if (!isBrowser) return false

  loginUser(username, pwd, redirectPath, loginFailedCallback);

  return false
}


export const requestPwdReset = ({username}, callback) => {
  axios({
    method: 'post',
    url: `${api_base_url()}/passwordchange`,
    data: {
      username: username.toLowerCase()
    }
  }).then(function(response) {
    callback(true);
  })

  callback(false);
}


export const isLoggedIn = () => {
  if (!isBrowser) return false

  const userdata = getUserData()

  return !!userdata.cookie
}

export const getCurrentUser = () => isBrowser && getUserData()
export const getAdminData = () => isBrowser && getAdminUserData()

export const logout = callback => {
  if (!isBrowser) return

  setUserData({})
  setAdminUserData(null);
  if (callback) {
    callback()
  }
}


function stringsplit(str) {
  const i = str.indexOf(".");
  if(i > 0)
    return  str.slice(0, i);
  else
    return str;
}

export const api_base_url = () => {
  return process.env.GATSBY_API_URL;
}


export const medialike_base_url = () => {
  return process.env.MEDIALIKE_URL;
}


export const medialike_images_base_url = () => {
  return process.env.MEDIALIKE_IMAGES_URL;
}

export const browserstring = () => {
  return (platform.name ? platform.name : "") +
    (platform.layout ? platform.layout : "") +
    (platform.manufacturer ? platform.manufacturer : "") +
    platform.os.toString()+
    (platform.prerelease ? platform.prerelease : "") +
    (platform.product ? platform.product : "") +
    (platform.version ? stringsplit(platform.version) : "");
}